import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Privacy() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-451">Política de Privacidad</h1>
        <p className="muted" data-id="element-452">Última actualización: 29 de mayo de 2026</p>

        <h2 data-id="element-453">1. Quiénes somos</h2>
        <p data-id="element-454">
          Lipo Laser · Dermaclinic Beverly Hills ("nosotros", "nuestro") opera
          el sitio web lipolaserbeverlyhills.com (el "Sitio"). Nos comprometemos
          a proteger su privacidad y la información personal que comparte con
          nosotros.
        </p>

        <h2 data-id="element-455">2. Información que recopilamos</h2>
        <p data-id="element-456">Cuando interactúa con nuestro Sitio, podemos recopilar:</p>
        <ul data-id="element-457">
          <li data-id="element-458">
            <strong data-id="element-459">Información que usted proporciona:</strong> nombre,
            apellido, correo electrónico, número de teléfono, ciudad y
            preferencias de contacto cuando completa nuestro formulario de
            consulta privada.
          </li>
          <li data-id="element-460">
            <strong data-id="element-461">Información automática:</strong> dirección IP, tipo de
            navegador, dispositivo, páginas visitadas, tiempo de permanencia,
            fuente de tráfico.
          </li>
          <li data-id="element-462">
            <strong data-id="element-463">Cookies y tecnologías similares:</strong> utilizamos cookies
            y el Meta Pixel para mejorar su experiencia, medir el rendimiento
            del sitio y personalizar la publicidad.
          </li>
        </ul>

        <h2 data-id="element-464">3. Cómo usamos su información</h2>
        <ul data-id="element-465">
          <li data-id="element-466">Responder a su solicitud de consulta privada.</li>
          <li data-id="element-467">Proporcionarle información sobre nuestros servicios.</li>
          <li data-id="element-468">Mejorar la experiencia del sitio y nuestros servicios.</li>
          <li data-id="element-469">Cumplir con obligaciones legales.</li>
          <li data-id="element-470">
            Enviar comunicaciones de marketing (solo con su consentimiento
            expreso).
          </li>
          <li data-id="element-471">
            Medir el rendimiento de campañas publicitarias en Meta
            (Facebook/Instagram), Google y otras plataformas.
          </li>
        </ul>

        <h2 data-id="element-472">4. Compartir información con terceros</h2>
        <p data-id="element-473">
          No vendemos su información personal. Compartimos información limitada
          con:
        </p>
        <ul data-id="element-474">
          <li data-id="element-475">
            <strong data-id="element-476">Proveedores de servicios</strong> que nos ayudan a operar
            (GoHighLevel para CRM, Meta para publicidad).
          </li>
          <li data-id="element-477">
            <strong data-id="element-478">Autoridades</strong> cuando lo exija la ley.
          </li>
        </ul>

        <h2 data-id="element-479">5. Meta Pixel y publicidad</h2>
        <p data-id="element-480">
          Utilizamos Meta Pixel para medir la efectividad de nuestras campañas
          publicitarias en Facebook e Instagram. Esta tecnología puede recopilar
          información sobre sus visitas a nuestro sitio. Puede gestionar sus
          preferencias de publicidad en{' '}
          <a href="https://www.facebook.com/settings?tab=ads" target="_blank" rel="noopener noreferrer" data-id="element-481">
            configuración de anuncios de Facebook
          </a>
          .
        </p>

        <h2 data-id="element-482">6. Sus derechos</h2>
        <p data-id="element-483">Usted tiene derecho a:</p>
        <ul data-id="element-484">
          <li data-id="element-485">Acceder a la información personal que tenemos sobre usted.</li>
          <li data-id="element-486">Solicitar la corrección o eliminación de su información.</li>
          <li data-id="element-487">Retirar el consentimiento de marketing en cualquier momento.</li>
          <li data-id="element-488">Presentar una queja ante autoridades de protección de datos.</li>
        </ul>

        <h2 data-id="element-489">7. Residentes de California (CCPA)</h2>
        <p data-id="element-490">
          Bajo la Ley de Privacidad del Consumidor de California (CCPA), tiene
          derechos adicionales, incluyendo el derecho a saber qué información
          recopilamos, el derecho a eliminarla y el derecho a no ser
          discriminado por ejercer estos derechos.
        </p>

        <h2 data-id="element-491">8. Seguridad</h2>
        <p data-id="element-492">
          Implementamos medidas técnicas y organizativas razonables para
          proteger su información. Sin embargo, ninguna transmisión por internet
          es 100% segura.
        </p>

        <h2 data-id="element-493">9. Información médica (HIPAA)</h2>
        <p data-id="element-494">
          Lipo Laser · Dermaclinic Beverly Hills cumple con la Ley de
          Portabilidad y Responsabilidad del Seguro de Salud (HIPAA) en todo el
          manejo de información médica protegida (PHI). La información
          proporcionada en el formulario de contacto no se considera información
          médica protegida hasta que se establezca una relación médico-paciente
          formal.
        </p>

        <h2 data-id="element-495">10. Cambios a esta política</h2>
        <p data-id="element-496">
          Podemos actualizar esta política. La fecha de "última actualización"
          al inicio refleja la versión más reciente.
        </p>

        <h2 data-id="element-497">11. Contacto</h2>
        <p data-id="element-498">
          Si tiene preguntas sobre esta política, contáctenos en:{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-499">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </> : <>
        <h1 data-id="element-500">Privacy Policy</h1>
        <p className="muted" data-id="element-501">Last updated: May 29, 2026</p>

        <h2 data-id="element-502">1. Who we are</h2>
        <p data-id="element-503">
          Lipo Laser · Dermaclinic Beverly Hills ("we", "us", "our") operates
          lipolaserbeverlyhills.com (the "Site"). We are committed to protecting
          your privacy and the personal information you share with us.
        </p>

        <h2 data-id="element-504">2. Information we collect</h2>
        <p data-id="element-505">When you interact with our Site, we may collect:</p>
        <ul data-id="element-506">
          <li data-id="element-507">
            <strong data-id="element-508">Information you provide:</strong> first name, last name,
            email, phone number, city, and contact preferences when you complete
            our private consultation form.
          </li>
          <li data-id="element-509">
            <strong data-id="element-510">Automatic information:</strong> IP address, browser type,
            device, pages visited, time spent, traffic source.
          </li>
          <li data-id="element-511">
            <strong data-id="element-512">Cookies and similar technologies:</strong> we use cookies
            and the Meta Pixel to improve your experience, measure site
            performance, and personalize advertising.
          </li>
        </ul>

        <h2 data-id="element-513">3. How we use your information</h2>
        <ul data-id="element-514">
          <li data-id="element-515">Respond to your private consultation request.</li>
          <li data-id="element-516">Provide information about our services.</li>
          <li data-id="element-517">Improve site experience and services.</li>
          <li data-id="element-518">Comply with legal obligations.</li>
          <li data-id="element-519">
            Send marketing communications (only with your express consent).
          </li>
          <li data-id="element-520">
            Measure performance of advertising campaigns on Meta
            (Facebook/Instagram), Google, and other platforms.
          </li>
        </ul>

        <h2 data-id="element-521">4. Sharing with third parties</h2>
        <p data-id="element-522">
          We do not sell your personal information. We share limited information
          with:
        </p>
        <ul data-id="element-523">
          <li data-id="element-524">
            <strong data-id="element-525">Service providers</strong> who help us operate (GoHighLevel
            for CRM, Meta for advertising).
          </li>
          <li data-id="element-526">
            <strong data-id="element-527">Authorities</strong> when required by law.
          </li>
        </ul>

        <h2 data-id="element-528">5. Meta Pixel and advertising</h2>
        <p data-id="element-529">
          We use the Meta Pixel to measure the effectiveness of our advertising
          campaigns on Facebook and Instagram. This technology may collect
          information about your visits to our site. You can manage your
          advertising preferences in{' '}
          <a href="https://www.facebook.com/settings?tab=ads" target="_blank" rel="noopener noreferrer" data-id="element-530">
            Facebook ad settings
          </a>
          .
        </p>

        <h2 data-id="element-531">6. Your rights</h2>
        <p data-id="element-532">You have the right to:</p>
        <ul data-id="element-533">
          <li data-id="element-534">Access the personal information we hold about you.</li>
          <li data-id="element-535">Request correction or deletion of your information.</li>
          <li data-id="element-536">Withdraw marketing consent at any time.</li>
          <li data-id="element-537">File a complaint with data protection authorities.</li>
        </ul>

        <h2 data-id="element-538">7. California Residents (CCPA)</h2>
        <p data-id="element-539">
          Under the California Consumer Privacy Act (CCPA), you have additional
          rights including the right to know what information we collect, the
          right to delete it, and the right not to be discriminated against for
          exercising these rights.
        </p>

        <h2 data-id="element-540">8. Security</h2>
        <p data-id="element-541">
          We implement reasonable technical and organizational measures to
          protect your information. However, no internet transmission is 100%
          secure.
        </p>

        <h2 data-id="element-542">9. Medical information (HIPAA)</h2>
        <p data-id="element-543">
          Lipo Laser · Dermaclinic Beverly Hills complies with the Health
          Insurance Portability and Accountability Act (HIPAA) in handling all
          Protected Health Information (PHI). Information provided in the
          contact form is not considered protected health information until a
          formal physician-patient relationship is established.
        </p>

        <h2 data-id="element-544">10. Changes to this policy</h2>
        <p data-id="element-545">
          We may update this policy. The "last updated" date at the top reflects
          the most recent version.
        </p>

        <h2 data-id="element-546">11. Contact</h2>
        <p data-id="element-547">
          If you have questions about this policy, contact us at:{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-548">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </>;
  return <LegalLayout data-id="element-549">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-550">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-551">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-552">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-553">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-554">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-555">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-556" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-557">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-558">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-559">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-560">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}